import { putSiteFetchFulfilled } from "./reducer";
import config from "../../../config";
import { IGcpAppDispatch } from "../../store";
import { performSignedRequest } from "../auth/asyncActions";
import { ISite } from "../../../apiFacades/csu/site";

export const fetchSite =
  (customerId: string, siteId: string) =>
  async (dispatch: IGcpAppDispatch): Promise<ISite> => {
    const resp = await dispatch(
      performSignedRequest(
        {
          method: "GET",
          url: `${config.endpoints.csuApi}/customers/${customerId}/sites/${siteId}`,
        },
        customerId,
        siteId,
      ),
    );
    dispatch(putSiteFetchFulfilled(resp.data.site));
    return resp.data.site;
  };
